import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslate } from "@customHooks/useTranslate.js";
export const LinkNav = ({
  children,
  tran,
  exact,
  category = null,
  to = "",
  important,
  target,
  classNames,
  rel,
  download,
}) => {
  const tranResult = useTranslate(tran, category);
  if (
    download ||
    to.toLowerCase().includes("https://") ||
    to.toLowerCase().includes("http://")
  ) {
    const attr = {};
    if (download) {
      attr["download"] = download;
    }
    return (
      <a
        className={classNames}
        important={important}
        aria-label={!tran || isNaN(tran) ? tran : tranResult}
        target={target}
        rel={rel}
        href={to}
        {...attr}
      >
        {children}
      </a>
    );
  } else {
    return (
      <NavLink
        className={classNames}
        important={important}
        aria-label={!tran || isNaN(tran) ? tran : tranResult}
        end={exact === "true" ? true : null}
        target={target}
        rel={rel}
        to={to}
      >
        {children}
      </NavLink>
    );
  }
};
